<nw-card
    class="notification-card"
    [class.notification-card--success]="
        type === NotificationType.success || type === 'success'
    "
    [class.notification-card--error]="type === NotificationType.error || type === 'error'"
    [class.notification-card--information]="
        type === NotificationType.information || type === 'information'
    "
    [class.notification-card--warning]="
        type === NotificationType.warning || type === 'warning'
    "
    [class.notification-card--no-fill]="!fill"
    (raiseEvent)="!loading ? raiseEvent.emit($event) : {}"
    [disabled]="loading"
>
    <div class="notification-card__prefix" role="prefix">
        @if (!loading) {
            <ng-content select="[role=prefix]"></ng-content>
        } @else {
            <div class="notification-card__loading-bar"></div>
        }
    </div>
    <div role="header" class="notification-card__header">
        @if (icon) {
            @if (!loading) {
                <nw-icon class="notification-card__header__icon" [icon]="icon"></nw-icon>
            } @else {
                <div class="notification-card__loading-circle"></div>
            }
        }
        @if (!loading) {
            <ng-content select="[role=header]"></ng-content>
        } @else {
            <div class="notification-card__loading-bar"></div>
        }
    </div>
    <div role="body">
        @if (!loading) {
            <ng-content select="[role=body]"></ng-content>
        } @else {
            <div class="notification-card__loading-bar"></div>
            <div
                class="notification-card__loading-bar notification-card__loading-bar--margin"
            ></div>
        }
    </div>
</nw-card>
